<p-dialog
  [(visible)]="visibleDialog"
  [style]="{ width: '50%', height: '80%' }"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [draggable]="false">
  <ng-template pTemplate="header">
    <div class="header-name ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ "userProfile.modifyProfile" | translate }}
      </h1>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-stepper [(activeStep)]="activeIndex">
      <!-- Données personnelles -->
      <p-stepperPanel [header]="'modifyPolicy.headerPersonalData' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-nextCallback="nextCallback"
          let-index="index">
          <app-personal-data
            [policyFieldsVM]="policyFieldsVM"
            [phonePrefixes]="phonePrefixes"
            [selectedPhonePrefix]="selectedPhonePrefix"
            [member]="member"
            [memberCopy]="memberCopy"
            [countriesOptions]="countriesOptions"
            [hasEndorsementWait4Sign]="hasEndorsementWait4Sign"
            (emitFormValidity)="onFormValidityChange($event)"
            (emitPhoneMask)="onPhoneMaskChange($event)"
            (emitCountryHasChange)="onCountryHasChange($event)"
            (emitNationalityHasChange)="onNationalityHasChange($event)"
            (emitPhoneNumberHasChange)="onPhoneNumberHasChange($event)"
            (emitPhonePrefixHasChange)="onPhonePrefixHasChange($event)"></app-personal-data>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel [header]="'modifyPolicy.headerConfirmation' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-index="index">
          <div class="flex flex-column h-12rem">
            <app-contract-changes
              #changes
              [policyChangeLog]="policyChangeLog"
              [displaySignaturePhone]="displaySignaturePhone"
              [phoneNumber]="selectedSignaturePhoneNumber"
              [phonePrefix]="selectedSignaturePhonePrefix"
              [phonePrefixes]="phonePrefixes"
              [multicontract]="hasMemberMultipleReferences"
              [reference]="policyChangeLog.contracts[0].reference"
              (signaturePhonePrefixChange)="onSignaturePhonePrefixChange($event)"
              (signaturePhoneNumberChange)="onSignaturePhoneNumberChange($event)"
              (signaturePhoneSignatureCheckboxChange)="
                onSignaturePhoneSignatureCheckBoxChange($event)
              "></app-contract-changes>
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-center space-x-4 pt-8">
      <button
        pButton
        type="button"
        label="Annuler"
        class="bg-white border-primary border-solid border-[1px] w-full p-3 text-primary"
        (click)="cancelStep()"></button>
      <button
        pButton
        type="button"
        label="Valider"
        class="bg-primary text-white w-full p-3"
        [disabled]="!isFormValid[activeIndex] || !hasChanged()"
        (click)="validateStep()"></button>
    </div>
  </ng-template>
</p-dialog>
<app-ok-dialog
  *ngIf="IsCallInErrorDialogVisible"
  message="{{ 'common.errorMessage' | translate }}"
  title="{{ 'common.errorMessageTitle' | translate }}"
  okLabel="{{ 'common.ok' | translate }}"
  (visibleChange)="onCallInErrorDialogVisible()">
</app-ok-dialog>
<app-ok-dialog
  *ngIf="IsSaveDialogVisible"
  message="{{ 'common.saveMessage' | translate }}"
  title="{{ 'common.saveMessageTitle' | translate }}"
  okLabel="{{ 'common.ok' | translate }}"
  [cancelButton]="true"
  (closeDialogEvent)="onSaveDialogClose($event)">
</app-ok-dialog>
